import React, { useEffect, useState } from 'react';
import { HamidRezaAhmadiImage, AdelTalebiImage } from '../../../assets/avatars';
import { BarayandIcon, EvendIcon } from '../../../assets/icons';
import './styles.scss';
import useTranslation from 'hooks/useTranslation';

const AuthRandomQuote = (props) => {
  const [selectedQuote, setSelectedQuote] = useState(0);

  const { getTranslation } = useTranslation('COMMON');
  const { t } = getTranslation();

  const randomQuotes = [
    {
      fullName: t('QUOTE_1').NAME,
      imageUrl: AdelTalebiImage,
      text: t('QUOTE_1').TEXT,
      logoUrl: BarayandIcon,
    },
    {
      fullName: t('QUOTE_2').NAME,
      imageUrl: HamidRezaAhmadiImage,
      text: t('QUOTE_2').TEXT,
      logoUrl: EvendIcon,
    },
  ];

  const { imageUrl, text, logoUrl, fullName } = randomQuotes[selectedQuote];

  useEffect(() => {
    setSelectedQuote(Math.floor(Math.random() * 2));
  }, []);

  return (
    <div className='testimoial_login flex'>
      <img src={imageUrl} alt='' className='avatar' />
      <div className='quote'>
        <blockquote>{text}</blockquote>
      </div>
      <div className='customer_name'>
        <p>{fullName}</p>
      </div>
      <img src={logoUrl} alt='' className='business_logo' />
    </div>
  );
};

export default AuthRandomQuote;
